import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import React from "react";
import { useParams } from "react-router-dom";
import { PIXEL_TRACKING_KEYS } from "../PixelTracking/constants/PixelTracking.constants";
import { usePixelTracking } from "../PixelTracking/utils/usePixelTracking";

export const ManageOfferingSwitch = ({
  subSectionKey,
  invertedMode = false,
  endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
}) => {
  const { onOverrideIDChange } = usePixelTracking();
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[subSectionKey] || {};
  const { value } = subSectionConfig;
  const { listing_uuid } = useParams();

  const { handleSectionChange } = useAccountSectionUnlocking();

  const handleChange = () => {
    if (subSectionKey === PIXEL_TRACKING_KEYS.OVERIDE_ACCOUNT_LEVEL_FB_TOKEN) {
      return onOverrideIDChange();
    }

    const payload = {
      listing_uuid,
      feature_key: subSectionKey,
      feature_value: !value,
    };
    handleSectionChange({
      endPoint,
      payload,
    });
  };

  return (
    <SectionUnlockingSwitch
      value={invertedMode && value !== null ? !value : value}
      onChange={handleChange}
    />
  );
};
